<template>
    <div class="input-group">
        <div class="input-with-icon">
            <input
                type="text"
                id="suggest"
                class="form-control"
                :class="inputClasses"
                :placeholder="placeholder"
                v-model="address"
                @keyup.enter="onEnter"
                @keydown.enter="onEnter"
                @click="onClick"
                :disabled="isDisabled"
            >
            <i class="icn-small-close" :class="{ 'disabled-icon': isDisabled }" @click="onClear" v-if="address"></i>
        </div>
    </div>
</template>

<script>
/**
 * Компонент для ввода адреса доставки
 * @prop value
 * @prop placeholder
 * @emits input {addressText, data}
 */

export default {
    name: "AddressInputYandex",
    props: {
        value: {
            type: Object,
            required: true
        },
        placeholder: {
            type: String,
            required: false
        },
        oClasses: {
            type: Object,
            default() {
                return {};
            }
        },
        bounds: {
            type: Array,
            required: false
        },
        results: {
            type: Number,
            required: false
        },
        isOperator: {
            type: Boolean,
            required: false
        },
        isNeedGeocode: {
            type: Boolean,
            required: false
        },
        isDisabled: {
            type: Boolean,
            required: false
        },
        deliveryCalculator1C: {
            type: Boolean,
            required: false
        }
    },

    data() {
        return {
            deliveryAddress: null,
            deliveryAddressText: "",
            boundsPoint: this.bounds,
            search: this.value ? this.value.addressText : "",
            suggestions: [],
            suggestViewElem: null,
            address: this.value ? this.value.addressText : "",
            resultsQuantity: this.results ? this.results : 5,
            isYandexApiErrorShown: false,
        };
    },

    computed: {
        inputClasses() {
            return { ...this.oClasses };
        }
    },

    watch: {
        bounds: function (newVal, oldVal) {
            this.boundsPoint = newVal;
            this.initSuggest();
        },
        value: function (newVal, oldVal) {
            this.address = newVal.addressText;
        },
    },

    created() {},

    methods: {
        onEnter(e) {
            e.preventDefault();
        },
        onClick(e) {
            if (e.target.value === "" && !window.deliveryAddressClick) {
                if (document.querySelector('[data-bs-target="#modal-shipment-cities"]')) {
                    this.sendToGa("delivery", "inputAddressClick");
                } else if (document.querySelector(".address-form-input")) {
                    this.sendToGa("order", "deliveryAddressClick");
                }
            }
            window.deliveryAddressClick = true;
        },
        onInput() {
            let self = this;
            let suggests = ymaps
                .suggest(this.search, {
                    boundedBy: self.boundsPoint,
                    results: 5,
                })
                .then(function (items) {
                    self.suggestions = items;
                });
        },
        addressSelect(evt) {
            evt.preventDefault();
            let self = this;
            var q = evt.get("item").value;
            var geoType = evt.get("item").type;
            this.address = q;
            if(document.querySelector('[data-bs-target="#modal-shipment-cities"]')) {
              this.sendToGa('delivery','inputAddressDropdown');
            } else if(document.querySelector('.address-form-input')) {
              this.sendToGa('order','deliveryAddressDropdown', (window.VOrderComponent.total.ORDER_WEIGHT/1000).toFixed(3), window.basketItems);
            }
            localStorage.removeItem("isNeedSetPlacemark");
            if (self.deliveryCalculator1C) {
                let newAddress = {
                    addressText: q,
                    data: {
                        city: null,
                        coords: null,
                        geoType: geoType,
                    },
                };
                this.deliveryAddress = newAddress;
                this.deliveryAddressText = q;
                this.$emit("change", this.deliveryAddress);
                return;
            }

            BX.Evraz.getCoordsByAddress(q, this, callbackSuccess, callbackError);

            function callbackSuccess(response) {
                let newAddress = {
                    addressText: this.getYandexRequestAddress(response),
                    data: {
                        city: this.getYandexRequestCity(response),
                        coords: this.getYandexRequestCoord(response),
                    },
                };
                this.deliveryAddress = newAddress;
                this.deliveryAddressText = newAddress.addressText;
                localStorage.setItem("deliveryAddress", newAddress.addressText);
                this.$emit("change", this.deliveryAddress);
            }
            function callbackError(err) {
                let newAddress = {
                    addressText: this.address,
                    data: {},
                };
                this.deliveryAddress = newAddress;
                this.deliveryAddressText = this.address;
                this.$emit("change", this.deliveryAddress);
                if (this.isOperator && !this.isYandexApiErrorShown) {
                    this.isYandexApiErrorShown = true;
                    BX.Evraz.showDebugMessage("Недоступен сервис яндекс карт: " + err.errors[0].code);
                }
                console.log(err);
            }
        },
        getYandexRequestAddress(response) {
            return response.data.response.GeoObjectCollection.metaDataProperty.GeocoderResponseMetaData.request;
        },
        getYandexRequestCoord(response) {
            return response.data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(" ").reverse();
        },
        getYandexRequestCity(response) {
            try {
                const city =
                    response.data.response.GeoObjectCollection.featureMember[0].GeoObject.metaDataProperty.GeocoderMetaData.Address.Components.find(
                        (obj, index) => {
                            if (obj.kind === "locality") return true;
                        }
                    );
                if (city) {
                    return city.name;
                } else {
                    return "";
                }
            } catch (e) {
                return "";
            }
        },
        onClear() {
            if (this.isDisabled) return;
            this.address = "";
            this.$emit("change", { addressText: "", data: null });
            if (document.querySelector('[data-bs-target="#modal-shipment-cities"]')) {
                this.sendToGa("delivery", "inputAddressDel");
            }
        },
        initSuggest() {
            if (typeof ymaps != "undefined" && typeof ymaps.SuggestView != "undefined") {
                if (this.suggestViewElem) {
                    this.suggestViewElem.destroy();
                }

                var suggestView = new ymaps.SuggestView("suggest", {
                    boundedBy: self.boundsPoint,
                    results: this.resultsQuantity,
                    offset: [0, 3],
                    zIndex: 55,
                });

                this.suggestViewElem = suggestView;
                suggestView.events.add("select", self.addressSelect);
            }
        },
        sendToGa(eventCategory, eventAction, orderWeight, basketItems) {
            if (
                (document.querySelector(".delivery-page") &&
                    document.querySelector('[data-bs-target="#modal-shipment-cities"]')) ||
                document.querySelector(".address-form-input")
            ) {
                let dimension = {
                    dimension7: window.dimension7,
                    dimension11: window.dimension11,
                    dimension15: localStorage.getItem("deliveryAddress")
                        ? localStorage.getItem("deliveryAddress")
                        : document.querySelector("#suggest").value,
                };
                if (orderWeight && basketItems) {
                    dimension = {
                        dimension7: window.dimension7,
                        dimension9: orderWeight,
                        dimension10: basketItems,
                        dimension11: window.dimension11,
                        dimension15: localStorage.getItem("deliveryAddress")
                            ? localStorage.getItem("deliveryAddress")
                            : document.querySelector("#suggest").value,
                    };
                }
                gaPush.sendToGA("GAevent", eventCategory, eventAction, window.dimension11, dimension);
            }
        },
    },

    mounted() {
        self = this;
        if (typeof ymaps !== "undefined") {
            ymaps.ready(self.initSuggest);
        }
        if (!this.isNeedGeocode) {
            localStorage.setItem("isNeedSetPlacemark", true);
        }
    },
};
</script>

<style scoped>
.icn-small-close {
    font-weight: bold;
}
.disabled-icon {
    color: #e8e9e9;
}
span.custom-suggestions__label {
    padding-bottom: 2px;
}

.custom-suggestions {
    display: block;
    padding: 8px 0;
    margin-left: 0 !important;
    margin-top: -1px;
    z-index: 55;
}

/* Отмена */
.custom-suggestions__list li:hover {
    background-color: white;
}

.custom-suggestions__list li.hovered {
    background-color: #fde3ab;
}

.custom-suggestions__list li.selected {
    background-color: #fde3ab;
    font-weight: 500;
}

.pr-32 {
    padding-right: 2rem !important;
}
.input-group ymaps[class*="suggest-highlight"] {
    color: #ed7817;
    font-weight: normal;
}
.input-group ymaps[class*="__suggest-item"] {
    font-size: 16px;
    padding: 1px 9px;
    font-family: "GT Eesti Pro Text", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans",
        "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.input-group ymaps[class*="suggest-item_selected_yes"] {
    background: #fde3ab;
}
</style>
